const sortByForm = document.getElementById('collection-form');
const sortByField = document.getElementById('sort_by');
const collectionProducts = document.querySelector('#collection-products');
const filterEl = document.getElementById('filter');

let filterFirstRun = true;

export function sort() {
	

	sortByForm.addEventListener('submit', (e) => {
		e.preventDefault();
	})

	sortByField.addEventListener('change', (e) => {
		const url = document.location.toString().split('?')[0];
		const data = new FormData(sortByForm);

		updateCollection(url, data)
	})

}

export function filter() {

	const filterLinks = document.querySelectorAll('[data-link-collection]');
	const links = Array.from(filterLinks);
	const filterToggles = Array.from(document.querySelectorAll('.js-filter-toggle'));
	const filterBlockToggles = Array.from(document.querySelectorAll('.js-filter-block-toggle'));

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const url = e.target.href;
			// const data = new FormData(sortByForm);
			const filterBlockId = filterEl.querySelector('.is-open') ? filterEl.querySelector('.is-open').getAttribute('id') : null;

			updateCollection(url, null, filterBlockId);
		}, true)
	});
	
	filterToggles.forEach(toggle => {
		toggle.addEventListener('click', toggleFilter, true)
	})

	filterBlockToggles.forEach(toggle => {
		toggle.addEventListener('click', (e) => {
			e.preventDefault();
			const href = e.target.href;
			const id = href.split('#')[1];

			if (id === 'filter-index') {
				document.querySelector('.filter__block.is-open').classList.remove('is-open');
			} else {
				filterEl.querySelector(`#${id}`).classList.add('is-open');
			}
		}, true)
	})

	if (filterFirstRun) {
		updateRefs(document);
		filterFirstRun = false
	}

}

function toggleFilter(e) {
	e.preventDefault();
	document.documentElement.classList.toggle('filter-is-open');
	filterEl.classList.toggle('is-open');
}

function updateCollection(url, data, activeFilterId) {
	const searchParams = data ? new URLSearchParams(data) : '';
	const fetchUrl = data ? `${url}?${searchParams}` : url

	collectionProducts.classList.add('is-loading');
	filterEl.classList.add('is-loading');

	fetch(fetchUrl)
    .then(function(response) {
			(searchParams, fetchUrl)
        // When the page is loaded convert it to text
        return response.text()
    })
    .then(function(html) {
        // Initialize the DOM parser
        const parser = new DOMParser();
        // Parse the text
				const doc = parser.parseFromString(html, "text/html");

				const productsHtml = doc.querySelector('#collection-products');

				updateRefs(doc);

				let filterHtml = doc.querySelector('#filter');

				if (activeFilterId) {
					filterHtml.querySelector(`#${activeFilterId}`).classList.add('is-open');
				}
				
				window.history.pushState({}, null, fetchUrl);
				
				return updateUI(filterHtml.innerHTML, productsHtml.innerHTML);
		})
		.then(function() {
			return filter();
		})
		.then(function() {
			collectionProducts.classList.remove('is-loading');
			filterEl.classList.remove('is-loading');
			window.lazy.init();
			window.addGaEvents();
			window.cardScores();
		})
    .catch(function(err) {  
        console.log('Failed to fetch page: ', err);  
    });
}

function updateRefs(doc) {

	const activeFilter = doc.querySelectorAll('.filter__row.is-active');

	Array.from(activeFilter).forEach((item, i) => {
		let val = item.dataset.filterValue;
		let type = item.dataset.filterType;
		let ref = doc.querySelector(`[data-filter=${type}] .js-filter-ref`);
		let refHTML = ref.innerHTML;
		return ref.innerHTML = `${refHTML} ${val}${i !== activeFilter.length - 1 ? ',' : ''}`
	});
}

function updateUI(filterHtml, collectionHtml) {
	filterEl.innerHTML = filterHtml;
	collectionProducts.innerHTML = collectionHtml;
	return
}